import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "page-section bg-dark",
  id: "seasons"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-2" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "col-sm" }
const _hoisted_7 = { class: "card bg-light" }
const _hoisted_8 = { class: "card-header" }
const _hoisted_9 = { class: "card-body" }
const _hoisted_10 = { class: "card-title" }
const _hoisted_11 = { class: "card-text" }
const _hoisted_12 = { class: "card-body" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { class: "card-header section-heading text-uppercase text-white" }
const _hoisted_15 = ["href"]
const _hoisted_16 = { class: "col-sm" }
const _hoisted_17 = ["src"]

import { seasons } from '@/data/seasons'

export default /*@__PURE__*/_defineComponent({
  __name: 'SeasonsSection',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-center" }, [
        _createElementVNode("h2", { class: "section-heading text-uppercase text-white" }, "SEASONS"),
        _createElementVNode("h3", { class: "section-subheading text-white" }, "Team 7770 has been competing in the FIRST Robotics Competition since 2019.")
      ], -1)),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(seasons), (season) => {
          return (_openBlock(), _createElementBlock("div", {
            key: season,
            class: "container col-md-12 bg-white rounded p-2 m-2"
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", null, [
                  _createElementVNode("img", {
                    src: season.image,
                    height: "125",
                    width: "125"
                  }, null, 8, _hoisted_5)
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(season.year) + " - " + _toDisplayString(season.name), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("h5", _hoisted_10, "Robot: " + _toDisplayString(season.robot), 1),
                    _cache[0] || (_cache[0] = _createElementVNode("h5", { class: "card-title" }, "Features:", -1)),
                    _createElementVNode("ul", _hoisted_11, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(season.features, (feature) => {
                        return (_openBlock(), _createElementBlock("li", { key: feature }, _toDisplayString(feature), 1))
                      }), 128))
                    ]),
                    _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "card-title" }, "Awards:", -1)),
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(season.awards, (award) => {
                        return (_openBlock(), _createElementBlock("li", { key: award }, _toDisplayString(award), 1))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("iframe", {
                      height: "225",
                      src: `https://www.youtube.com/embed/${season.youtube}`,
                      title: "YouTube video player",
                      frameborder: "0",
                      allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
                      allowfullscreen: ""
                    }, null, 8, _hoisted_13)
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("a", {
                      href: `https://www.thebluealliance.com/team/7770/${season.year}`,
                      target: "_results",
                      class: "results-link"
                    }, "Results", 8, _hoisted_15)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("img", {
                  class: "img-fluid",
                  src: season.pic,
                  height: "350"
                }, null, 8, _hoisted_17)
              ])
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}
}

})